import React from "react";
import ThankYou from "../../components/ThankYou";

export default function THaida() {
  return (
    <div>
      <ThankYou />
    </div>
  );
}
